import { ISegmentStepProps } from "./StepSegment";
import { createSxStyles } from "../../common/createSxStyles";
import { useIsBetweenSize, useIsOnExtraSmallScreen, useIsOnLargeScreen, useIsOnMediumScreen } from "@dotlegal/dotlegal-ui-components";

export const useStepSegmentStyles = (props: ISegmentStepProps) => {
    const isMediumScreen = useIsOnMediumScreen();
    const isExtraSmallScreen = useIsOnExtraSmallScreen();
    const isLargeScreen = useIsOnLargeScreen();
    const isExtraLarge = useIsBetweenSize(1599, 1800);

    return createSxStyles({
        container: {
            position: "relative",
            width:
                props.size === "fullWidth"
                    ? "100%"
                    : props.size === "small"
                      ? isExtraSmallScreen
                          ? "85%"
                          : isLargeScreen
                            ? "70%"
                            : isMediumScreen
                              ? "80%"
                              : isExtraLarge
                                ? "50%"
                                : "40%"
                      : props.size === "medium"
                        ? isLargeScreen
                            ? "90%"
                            : isMediumScreen
                              ? "100%"
                              : "60%"
                        : isLargeScreen
                          ? "100%"
                          : "90%",
        },
    });
};
